<div (window:scroll)="onScroll($event)" class="d-lg"></div>